import React from 'react';

/**
 * Hidden field real users never see. Bots that auto-fill forms often populate it;
 * the API rejects non-empty values.
 */
const honeypotSx = {
  position: 'absolute',
  left: '-10000px',
  top: 'auto',
  width: '1px',
  height: '1px',
  overflow: 'hidden',
  opacity: 0,
  pointerEvents: 'none',
};

const HoneypotField = ({ value, onChange }) => (
  <div style={honeypotSx} aria-hidden="true">
    <label htmlFor="contact-website">Website</label>
    <input
      id="contact-website"
      type="text"
      name="website"
      tabIndex={-1}
      autoComplete="off"
      value={value}
      onChange={onChange}
    />
  </div>
);

export default HoneypotField;
